import type { PZItem } from '../../types/pz';

/**
 * Is the PRODUCT of this PZ line locked because it traces back to a supplier
 * order (ZD)?
 *
 * WP12 (1.18, owner decision 2026-09-24 "dopuśćmy to"): the PZ is the
 * physical fact, so the quantity of a traced line is always editable (an
 * over-receipt is its own confirmed warning). The product of a traced line on
 * a PZ not yet received may change too: the backend asks for a confirmed
 * warning (`PZ_SUPPLIER_ORDER_TRACE_BROKEN`) and breaks the trace, so the ZD
 * line regains its open quantity. Only a received PZ (a correction) keeps the
 * product locked (`PZ_SUPPLIER_ORDER_TRACE_LOCKED`): its batch valuation
 * belongs to the ZD line.
 *
 * Single home because the field it reads is easy to get wrong:
 * `sourceSupplierOrderItemId` LOOKS like the right signal, but
 * `responseFilter` strips it from every PZ response. The backend-computed
 * `supplierOrderTraceLocked` flag is the one to read.
 *
 * The remove button is never governed by this lock: an operator may remove a
 * traced line wholesale from an editable PZ — coverage is quantity-based off
 * persisted PZItem rows, so removal simply frees that ZD line's quantity.
 */
export function isPZItemProductTraceLocked(
  item: Pick<PZItem, 'supplierOrderTraceLocked'>,
  { documentReceived }: { documentReceived: boolean },
): boolean {
  return documentReceived && item.supplierOrderTraceLocked === true;
}
